export const ROUTE_BASE_NAME = "vehicles";

export const ROUTE_NAMES = {
  VehiclesMain: `${ROUTE_BASE_NAME}`,
  VehiclesList: `${ROUTE_BASE_NAME}.list`,
  VehiclesCreate: `${ROUTE_BASE_NAME}.create`,
  VehiclesEdit: `${ROUTE_BASE_NAME}.update`,
};
